import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'clientCaseId'})

export class ClientCaseIdPipe implements PipeTransform {
    transform(value: string) {
        if (!value) {
            return;
        }
        return value.replace(/~/g, ' ');
    }
}
